<template>
	<page-container :page="page">
		<heading-image
			v-if="page && page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content
			:title="page.title || page.header"
			:title-right="page.titleRight"
			:subtitle="page.subtitle"
			:content="page.content"
			:intro-image="page.introImage"
			:intro-image-webp="page.introImageWebp"
			:intro-image-portrait="page.introImagePortrait"
			:intro-image-portrait-webp="page.introImagePortraitWebp"
		/>

		<section class="main-content background-dark">
			<div v-for="item in newsPaginated" :key="item.ID" class="row blog-item">
				<div class="columns column6 left">
					<h4 v-if="item.date" class="subtitle">
						{{ $d(new Date(item.date.date.split(' ')[0]), 'short') }}
					</h4>
					<h3>
						<nuxt-link :to="localePath(`/${item.filename}`)">
							{{ item.title || item.header }}
						</nuxt-link>
					</h3>
					<p>{{ item.contentShort }}</p>
					<button-container>
						<nuxt-link :to="localePath(`/${item.filename}`)" class="button-arrow">
							{{ $t('viewNews') }}
						</nuxt-link>
					</button-container>
				</div>
				<div class="columns column6 right">
					<nuxt-link :to="localePath(`/${item.filename}`)">
						<picture>
							<source :srcset="item.imageOverviewWebp" type="image/webp" />
							<source :srcset="item.imageOverview" />
							<img :src="item.imageOverview" :alt="item.imageOverviewAlt" loading="lazy" />
						</picture>
					</nuxt-link>
				</div>
			</div>
			<div v-if="news.length > newsPaginated.length" id="showMoreNews" class="row align-center">
				<button class="button" @click="currentPage++">
					{{ $t('readMore') }}
				</button>
			</div>
		</section>

		<contentblocks v-if="page.contentblocks && page.contentblocks.length" :items="page.contentblocks" />

		<review-slider v-if="page.showReviewSlider" :header="defaults[locale].website.reviewsHeader" />

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>

		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const localePath = useLocalePath();

await fetchPage();
await fetchDefaults();

const { data: news } = await useWebsiteFetch('news', {
	query: { language: locale.value },
	key: `${locale.value}/news`,
});

const currentPage = ref(1);
const itemsPerPage = 3;

const newsPaginated = computed(() => {
	return news.value.slice(0, currentPage.value * itemsPerPage);
});
</script>

<style lang="scss" scoped>
.blog-item {
	margin: 50px auto 100px;

	&:last-child {
		margin-bottom: 25px;
	}

	.subtitle {
		color: #fff;
	}
}

@media (max-width: 960px) {
	.blog-item .columns {
		padding: 20px 40px;
	}
}
</style>
